module.exports = __webpack_public_path__ + "static/media/outbound_icon-focused.e86753b5.svg";